/* eslint-disable @typescript-eslint/no-explicit-any */
import { useSnapshot } from "valtio";

import React from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";

import { getColorFromButton } from "@components/OrderTaking/Helpers";
import { RootState } from "@components/OrderTaking/Store";

import { kioskStore } from "@pages/Kiosk/store";

export default function usePromoCodeHook(): usePromoCodeHookType {
    const dispatch = useDispatch();
    const { devise } = useSnapshot(kioskStore);
    const [isExpanded, setIsExpanded] = React.useState(false);

    const {
        usedGifts,
        order: { totalPrice, totalPriceWithOutFidelity, orderItems },
    } = useSelector((state: RootState) => state.orderSlice, shallowEqual);

    const productCodePromo = orderItems.filter(
        (order: any) => order.discountedPrice
    );
    const discountValue =
        productCodePromo.length > 0
            ? (productCodePromo[0] as any).discountedPrice.toFixed(
                  devise.decimalPrice
              )
            : (totalPrice - totalPriceWithOutFidelity).toFixed(
                  devise.decimalPrice
              );

    const totalReduce = `${discountValue} ${devise.deviseSymbole}`;

    const textColor = getColorFromButton("--global-color");
    const btnColor = getColorFromButton(textColor);

    return {
        dispatch,
        usedGifts,
        totalReduce,
        btnColor,
        isExpanded,
        setIsExpanded,
        textColor,
    };
}
